import React from 'react';
import { useTheme } from './ThemeProvider';
import { cn } from '../utils';

export const ThemePreview: React.FC = () => {
  const { theme, setTheme, themes } = useTheme();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
      {themes.map((t) => (
        <div
          key={t}
          data-theme={t}
          className={cn(
            'card bordered cursor-pointer transition-all',
            theme === t && 'ring-2 ring-primary ring-offset-2 ring-offset-base-100'
          )}
          onClick={() => setTheme(t)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setTheme(t);
            }
          }}
          aria-label={`Select ${t} theme`}
          aria-pressed={theme === t}
        >
          <div className="card-body">
            <h3 className="card-title capitalize">{t}</h3>
            <div className="flex gap-2">
              <div className="badge badge-primary">Primary</div>
              <div className="badge badge-secondary">Secondary</div>
              <div className="badge badge-accent">Accent</div>
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
              <div
                className="bg-base-100 w-8 h-8 rounded border border-base-content/20"
                title="base-100"
              ></div>
              <div
                className="bg-base-200 w-8 h-8 rounded border border-base-content/20"
                title="base-200"
              ></div>
              <div
                className="bg-base-300 w-8 h-8 rounded border border-base-content/20"
                title="base-300"
              ></div>
            </div>
            <div className="flex gap-1 mt-2">
              <div className="badge badge-sm badge-info">Info</div>
              <div className="badge badge-sm badge-success">Success</div>
              <div className="badge badge-sm badge-warning">Warning</div>
              <div className="badge badge-sm badge-error">Error</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
